import React from 'react';
import img from '../Pages/image/pro2.png'

const Projects = () => {

    return (
        <div>
          <section class="text-gray-600 body-font">
        <div class="container mx-auto flex px-5 lg:py-24 py-8 md:flex-row flex-col items-center">
        <div class=" md:w-1/2 w-full mb-10 md:mb-0">
            <img class="object-cover object-center rounded shadow" alt="hero" src={img} />
          </div>
          <div class="flex flex-col flex-wrap lg:py-6 -mb-10 lg:w-1/2 lg:pl-12 lg:text-left text-center">
            <div class="flex flex-col mb-10 lg:items-start items-center">
              <div class="flex-grow text-left lg:pr-12 lg:px-0 px-5">
                <h1 class=" lg:text-6xl text-4xl mb-4 lg:text-left text-center font-bold gradient  ">Truck Spare Parts Manufacturing Company Website
                </h1>
                <p class="mb-8 leading-relaxed text-white text-base lg:text-left text-center">Jekula Ltd Manufacturing Truck spare parts for Vehicle.The Project Developed with React.js, Tailwind, Node.js, Express.js, Mongobd ,JWT.The company Supply spare parts to Dealer.Dealer can order min. and max. amount of parts. </p>
                <div class="flex lg:justify-left">
                  <button class="inline-flex text-white border-outline border border-0 py-2 px-6 bg shadow focus:outline-none  rounded text-lg"><a className='text-white' href='https://github.com/foyjur-192/jekula-Manufacturing-website--Client-Site.git' target="_blank" rel='noopener noreferrer'>Github Repo.</a></button>
                </div>
              </div>
            </div>
            <div className='grid grid-rows-2 grid-flow-col mb-5 ' >
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox bg mr-2" /><p className='font-medium text-white text-lg text-left'>React js</p> </div>
              <div  className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-lg text-left mb-8'>Tailwind</p> </div>
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-left'>Node js</p> </div>
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-lg  text-left'>Express.js</p> </div>
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-lg  text-left'>Mongodb</p> </div>
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-lg  text-left'>Firebase</p> </div>
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-lg  text-left'>JWT</p> </div>
              </div>
      
            <div><button class="btn btn-outline border hover:bg-cyan-400  mt-5 "><a className='text-white' href='https://jekula-manufacturing-website-client-site.vercel.app/' target="_blank" rel='noopener noreferrer'>DEMO</a></button></div>

          </div>
      
        </div>
      </section>

        </div>
    );
};

export default Projects;